




import { Component, Prop, Vue } from 'vue-property-decorator';
import { Dictionary } from '../../utils';

@Component
export default class HTMLMessage extends Vue {
  @Prop({ default: 'p' })
  private tag: string;

  @Prop({ required: true })
  private message: string;

  @Prop()
  private params: Dictionary<string | number>;

  get formattedMessage() {
    return this.params ? this.$options.filters.compileMessage(this.message, this.params) : this.message;
  }
}
